export const oxxioButtonColors = {
  // Primary onLight Text
  buttonPrimaryOnLightDefaultText: '{{ textColors.textPrimary }}',

  // Primary onLight Background
  buttonPrimaryOnLightDefaultBackground: '{{ secondaryColors.yellow100 }}',
  buttonPrimaryOnLightHoverBackground: '{{ secondaryColors.yellow120 }}',
  buttonPrimaryOnLightFocusBackground: '{{ secondaryColors.yellow100 }}',
  buttonPrimaryOnLightPressedBackground: '{{ secondaryColors.yellow120 }}',

  // Primary onDark Text
  buttonPrimaryOnColorDefaultText: '{{ textColors.textPrimary }}',
  buttonPrimaryOnColorHoverText: '{{ textColors.textPrimary }}',
  buttonPrimaryOnColorFocusText: '{{ textColors.textPrimary }}',
  buttonPrimaryOnColorPressedText: '{{ textColors.textPrimary }}',

  // Primary onDark Background
  buttonPrimaryOnColorDefaultBackground: '{{ secondaryColors.yellow100 }}',

  // Primary onDark Icon
  buttonPrimaryOnColorDefaultIcon: '{{ iconColors.iconPrimary }}',
  buttonPrimaryOnColorHoverIcon: '{{ iconColors.iconPrimary }}',
  buttonPrimaryOnColorFocusIcon: '{{ iconColors.iconPrimary }}',
  buttonPrimaryOnColorPressedIcon: '{{ iconColors.iconPrimary }}',

  // Secondary
  buttonSecondaryDefaultText: '{{ brandColors.brandDarkBlue }}',
  buttonSecondaryDefaultBackground: '{{ neutralColors.neutralWhite }}',
  buttonSecondaryDefaultBorderColor: '{{ brandColors.brandDarkBlue }}',
  buttonSecondaryHoverText: '{{ brandColors.brandDarkBlue }}',
  buttonSecondaryHoverBackground: '{{ neutralColors.neutral100 }}',
  buttonSecondaryHoverBorderColor: '{{ brandColors.brandDarkBlue }}',
  buttonSecondaryFocusText: '{{ neutralColors.newBlack }}',
  buttonSecondaryFocusBackground: '{{ neutralColors.neutralWhite }}',
  buttonSecondaryFocusBorderColor: '{{ neutralColors.newBlack }}',
  buttonSecondaryPressedBackground: '{{ neutralColors.neutral100 }}',
  buttonSecondaryPressedText: '{{ neutralColors.black }}',
  buttonSecondaryPressedBorderColor: '{{ secondaryColors.blue900 }}',

  // Loading
  buttonLoadingDefaultText: '{{ textColors.textPrimary }}',
  buttonLoadingDefaultBackground: '{{ secondaryColors.yellow100 }}',
};

export const oxxioButtonBorderWidths = {
  buttonSecondaryDefaultBorderWidth: '{{ borderWidths.m }}',
};

export const oxxioButtonBorderRadii = {
  buttonBorderRadiusDefault: '{{ radii.round }}',
};

export const oxxioButtonChevronDisplay = {
  buttonChevronDisplay: 'block',
};
